import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../utils/utils";
import InfoBeneficiaryStep2Bloc from "../blocs/info-beneficiary/InfoBeneficiaryStep2Bloc";

export default function InfoBeneficiaryStep2Page() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
    
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Déclarez vos ayants droit</h1>
        <div ref={pageGapRef} className="page-gap"></div>
        <div className="page-content flex-grid bg-blanc shadow-noir p-lg m-lg-desktop">
            <InfoBeneficiaryStep2Bloc />
        </div>
      </div>
     
    )

}